import { getSiteUrl } from './siteConfig';
import { normalizeIntakeHostname } from './intakePublicUrl';

/** DNS TXT record host prefix (record is `_nexus-feedback.{yourFeedbackHostname}`). */
export const FEEDBACK_CUSTOM_HOST_TXT_PREFIX = '_nexus-feedback';

export type FeedbackCustomHostFields = {
  feedback_custom_hostname?: string | null;
  feedback_custom_host_verified_at?: string | null;
};

export const normalizeFeedbackHostname = normalizeIntakeHostname;

export function getFeedbackPublicOriginFromBusinessRow(
  business: FeedbackCustomHostFields | null | undefined,
): string {
  const host = normalizeFeedbackHostname(String(business?.feedback_custom_hostname ?? ''));
  const verified = Boolean(business?.feedback_custom_host_verified_at);
  if (host && verified) {
    return `https://${host}`;
  }
  return getSiteUrl();
}

export function buildPublicFeedbackUrl(token: string, publicOrigin: string): string {
  const base = (publicOrigin || getSiteUrl()).replace(/\/$/, '');
  return `${base}/feedback/${token}`;
}
